import React from 'react';

import strings from '../../../lang/lang';
import { Button } from '../../../elements';
import { ReactComponent as DeletIcon } from '../../../styles/icon/delete.svg';
import { useAppDispatch } from '../../../hooks/useRedux';
import { webhooksActions } from '../../../redux/reducers/webhooks';
import settings from '../Settings.module.scss';

function DangerZone(props) {
  const dispatch = useAppDispatch();

  return (
    <div className={settings.settings__info}>
      <h3>{strings.appWebhookDetails.text.dangerZone}</h3>
      <div className={settings.settings__danger_webhooks}>
        <div className={settings.settings__danger_text}>
          <strong>{strings.appWebhookDetails.text.deleteTitle}</strong>
          <p>{strings.appWebhookDetails.text.deleteDescription}</p>
        </div>
        <Button
          name={strings.appWebhookDetails.buttons.delete}
          variant="delete"
          type="submit"
          onClick={() => dispatch(webhooksActions.setActiveModalDetails({ name: 'delete a webhook'}))}
        >
          <DeletIcon />
        </Button>
      </div>
    </div>
  );
}

export default DangerZone;
